import { ROLE_ADMIN } from '../constants/roles';

/** Accès complet réservé à l’administrateur (pas aux modérateurs délégués). */
export function isAdministrateur(user) {
  return user?.role === ROLE_ADMIN;
}
